function JsonToMaterialTable( jsonData ) {
   
  const dataArray = Object.keys(jsonData).map((key) => {
    const obj = jsonData[key];
    return {
      id: key, // You can use the property name as the ID or assign a unique identifier
      name: obj.name,
      value: obj.value,
      tags: obj.tags,
      type: obj.type,
      // Add more fields as needed
    };
  });
  console.log("GOT SData here: ",dataArray)
  return dataArray;
}

export default JsonToMaterialTable;
